const WORDS = ["Safe", "Reliable", "Professional", "Elevator Solutions"];

export default function Marquee() {
  const seq = [...WORDS, ...WORDS, ...WORDS, ...WORDS];
  return (
    <section
      id="marquee"
      data-testid="marquee-section"
      className="overflow-hidden border-y border-[#0B3A82]/10 bg-white py-8 md:py-10"
    >
      <div className="animate-marquee">
        {seq.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="px-6 font-display text-4xl font-bold tracking-tight text-[#0B3A82] md:px-10 md:text-6xl">
              {w}
            </span>
            <span className="text-2xl md:text-4xl" style={{ color: "#D89A18" }}>
              ●
            </span>
          </span>
        ))}
      </div>
    </section>
  );
}
